import {useMemo} from 'react';
import {bulkUpdateCreateStaticSchema} from '../bulkUpdateSchemas';
import type {
  BulkUpdateValuesProps} from './useBulkUpdateValuesSchema';
import {
  useBulkUpdateValuesSchema,
} from './useBulkUpdateValuesSchema';

export const useBulkUpdateCreateSchema = (props: BulkUpdateValuesProps) => {
  const valuesSchema = useBulkUpdateValuesSchema(props);
  return useMemo(
    () => ({
      name: 'bulkUpdate',
      parts: [...bulkUpdateCreateStaticSchema.parts, ...valuesSchema.parts],
    }),
    [valuesSchema],
  );
};
